"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _head2 = _interopRequireDefault(require("lodash/head"));
var _orderBy2 = _interopRequireDefault(require("lodash/orderBy"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _reduxForm = require("redux-form");
var _formatAddress = require("../../formatAddress");
var _ReduxForm = _interopRequireDefault(require("angieslist-react-components/lib/ReduxForm"));
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));
var _Modal = _interopRequireDefault(require("angieslist-react-components/lib/Modal"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _getErrorMessage = _interopRequireDefault(require("angieslist-app-platform/lib/common/getErrorMessage"));
var _AddressComponent = _interopRequireDefault(require("angieslist-app-platform/lib/browser/addresscomponent/AddressComponent"));
var _addressComponentValidation = require("angieslist-app-platform/lib/browser/addresscomponent/addressComponentValidation");
var memberMgmtActions = _interopRequireWildcard(require("../../../../actions/memberMgmtGatewayActions"));
var myAccountUIActions = _interopRequireWildcard(require("../../../../actions/myAccountUIActions"));
var _memberMgmtGatewayActionKeys = _interopRequireDefault(require("../../../../constants/memberMgmtGatewayActionKeys"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var submit = function submit(_ref) {
  var addAddress = _ref.addAddress,
    reFetchUser = _ref.reFetchUser,
    changeCurrentAddress = _ref.changeCurrentAddress,
    values = _ref.values,
    userId = _ref.userId,
    userStore = _ref.userStore,
    handleClose = _ref.handleClose;
  var request = {
    userId: Number(userId),
    address: {
      makePrimary: values.makePrimary,
      firstLine: values.address.firstLine,
      secondLine: values.address.secondLine,
      city: values.address.city,
      regionAbbr: values.address.state,
      postalCode: values.address.zipCode
    }
  };
  addAddress(request).then(function () {
    reFetchUser(userId).then(function (reFetchUserResponse) {
      var newAddress = (0, _head2["default"])((0, _orderBy2["default"])((0, _get2["default"])(reFetchUserResponse, 'value.body.addresses', []), ['userAddressId'], ['desc']));

      // Note: At this time, we need to convert the "addressId: Number", to "addressId: String" and include "formattedAddress" so the Member Header Location bar display the new address correctly.
      var newAddressForMemberHeader = (0, _assign2["default"])({}, newAddress, {
        addressId: "".concat(newAddress.addressId),
        formattedAddress: (0, _formatAddress.formatAddress)(newAddress)
      });
      changeCurrentAddress(userStore, newAddressForMemberHeader);
    });
    handleClose();
  });
};
var AddAddressModal = function AddAddressModal(_ref2) {
  var userId = _ref2.userId,
    editButtonStyle = _ref2.editButtonStyle,
    handleSubmit = _ref2.handleSubmit,
    pristine = _ref2.pristine,
    invalid = _ref2.invalid,
    reFetchUser = _ref2.reFetchUser,
    userStore = _ref2.userStore,
    resetStore = _ref2.resetStore,
    changeCurrentAddress = _ref2.changeCurrentAddress,
    addAddress = _ref2.addAddress,
    _ref2$addAddressStore = _ref2.addAddressStore,
    isAddAddressLoading = _ref2$addAddressStore.isLoading,
    addAddressError = _ref2$addAddressStore.error,
    handleClose = _ref2.handleClose,
    showModal = _ref2.showModal;
  var errorMessage = (0, _getErrorMessage["default"])(addAddressError);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: showModal,
    onHide: handleClose,
    backdrop: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-location"
  }), "Add New Location"))), /*#__PURE__*/_react["default"].createElement("form", {
    name: "add-address-modal",
    onSubmit: handleSubmit(function (values) {
      return submit({
        addAddress: addAddress,
        reFetchUser: reFetchUser,
        changeCurrentAddress: changeCurrentAddress,
        values: values,
        userId: userId,
        userStore: userStore,
        handleClose: handleClose
      });
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-body"
  }, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "add-address-modal--make-primary",
    className: "control-label"
  }, "Make Primary:"), /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    id: "add-address-modal--make-primary",
    name: "makePrimary",
    type: "checkbox",
    label: "Check this to make it my primary location."
  }), /*#__PURE__*/_react["default"].createElement(_AddressComponent["default"], {
    showFieldWatermarkText: false
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "add-address-modal--save-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    type: "submit",
    disabled: pristine || invalid || isAddAddressLoading,
    loading: isAddAddressLoading
  }, "Save")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "add-address-modal--close-button",
    flat: true,
    bsStyle: "tertiary",
    bsSize: "small",
    onClick: function onClick() {
      resetStore(_memberMgmtGatewayActionKeys["default"].ADD_ADDRESS_RESET);
      handleClose();
    }
  }, "Cancel")))));
};
AddAddressModal.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  userId: _propTypes["default"].number.isRequired,
  resetStore: _propTypes["default"].func.isRequired,
  reFetchUser: _propTypes["default"].func.isRequired,
  changeCurrentAddress: _propTypes["default"].func.isRequired,
  addAddress: _propTypes["default"].func.isRequired,
  addAddressStore: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    error: _propTypes["default"].object
  }).isRequired,
  userStore: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var AddAddressModalReduxForm = (0, _reduxForm.reduxForm)({
  form: 'add-address-modal',
  validate: function validate(values) {
    return {
      address: _angieslistAppPlatform.validation.validate(values.address, (0, _addressComponentValidation.getAddressComponentValidationRules)().address).invalidAttrs
    };
  }
})(AddAddressModal);
var _default = exports["default"] = (0, _compose["default"])((0, _reactRedux.connect)(function (state) {
  return {
    addAddressStore: state.memberManagementGateway.addAddress,
    userStore: state.user
  };
}, _objectSpread(_objectSpread({}, memberMgmtActions), myAccountUIActions)), _pure["default"])(AddAddressModalReduxForm);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/myAccount/modals/addAddressModal.js
// module id = 4256
// module chunks = 9